/* eslint-disable */

import axios from 'axios';
import environment from '../enviroment.js';
export default new class {

    generationClient = this.axiosInstance();
    usageClient = this.axiosInstance();
    baseURL;
    generationToken;
    usageToken;
    tenant;

    axiosInstance() {
        const instance = axios.create({
            baseURL: environment.alisonServerApiUrl,
        });
        instance.interceptors.response.use(response => response.data, error => Promise.reject(error));
        return instance;
    }

    changeTenant(tenant) {
        this.tenant = tenant;
        this.generationClient.defaults.headers.common["X-Tenant"] = tenant;
        this.usageClient.defaults.headers.common["X-Tenant"] = tenant;
    }

    changeServerURL(serverURL) {
        this.baseURL = serverURL;
        this.generationClient.defaults.baseURL = serverURL;
        this.usageClient.defaults.baseURL = serverURL;
    }
    async updateGenerationToken(clientId = '', clientSecret = '') {
        if (clientId === '' && clientSecret === '') {
            clientId = environment.defaultServerGenerationClientId;
            clientSecret = environment.defaultServerGenerationClientSecret;
        }
        const credentials = new FormData();
        credentials.append('client_id', clientId);
        credentials.append('client_secret', clientSecret);
        credentials.append('grant_type', 'client_credentials');
        const response = await this.generationClient.post("/oauth/token", credentials);
        this.generationClient.defaults.headers.common["Authorization"] = "Bearer " + response.access_token;
        this.generationClient.defaults.headers.common["Content-Type"] = "application/json";
        this.generationToken = response.access_token;
        return response;
    }

    async updateUsageToken(clientId = '', clientSecret = '', scope) {
        const credentials = new FormData();
        credentials.append('client_id', clientId);
        credentials.append('client_secret', clientSecret);
        credentials.append('scope', scope);
        credentials.append('grant_type', 'client_credentials');
        const response = await this.usageClient.post("/oauth/token", credentials);
        this.usageClient.defaults.headers.common["Authorization"] = "Bearer " + response.access_token;
        this.usageClient.defaults.headers.common["Content-Type"] = "application/json";
        this.usageToken = response.access_token;
        return response;
    }

    async createSeat(name) {
        const body = { name };
        const { id } = await this.generationClient.post("/api/v1/seats", body);
        return id;
    }

    async createCredential(seatId, credentialData) {
        const body = credentialData;
        const { id } = await this.generationClient.post(`/api/v1/seats/${seatId}/credentials`, body);
        return id;
    }

    async addPin(pin, pinDescription, seatId, credentialId) {
        const body = {
            type: "PIN",
            secret: pin,
            description: pinDescription,
        };
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors`, body);
    }

    async generateQR(seatId, credentialId) {
        const body = { type: "OTP" };
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors`, body);
    }

    async verifyQRCode(otpCode, seatId, credentialId) {
        const body = { otp: otpCode };
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors/confirmation`, body);
    }

    async assignPhoneNumber(phone, seatId, credentialId) {
        const body = {
            type: "SMS",
            phone
        }
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors`, body);
    }

    async sendSMSCode(smsPreferences, seatId, credentialId) {
        const body = smsPreferences;
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors/send_phone_verification_sms`, body);
    }

    async assignEmail(email, seatId, credentialId) {
        const body = {
            type: "EMAIL",
            secret: email,
        };
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors`, body);
    }

    async sendEmailVerificationCode(email, seatId, credentialId) {
        const body = email;
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors/send_email_verification_code`, body);
    }

    async verifyEmail(emailCode, seatId, credentialId) {
        const body = {
            otp: emailCode
        }
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors/verify_email`, body);
    }

    async verifySMS(smsCode, seatId, credentialId) {
        const body = {
            otp: smsCode
        }
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors/verify_phone`, body);
    }

    async getWebAuthnCredentialOptions(seatId, credentialId) {
        return this.generationClient.get(`/api/v1/seats/${seatId}/credentials/${credentialId}/webauthn/attestation/options`);
    }

    async addWebAuthnCredential(authenticatorAttestationResponse, seatId, credentialId, displayName) {
        authenticatorAttestationResponse.displayName = displayName;
        const body = {
            type: "WEBAUTHN",
            webAuthn: authenticatorAttestationResponse,
        }
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/second_factors`, body);
    }

    async generateCSR(seatId, credentialId) {
        const body = {
          csrSignatureAlgorithm: "1.2.840.113549.1.1.11",
          key: {
            algo: "1.2.840.113549.1.1.1",
            len: 2048
          }
        }
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/key_pair`, body);
    }

    async installCertificate(pkcs7, seatId, credentialId) {
        const body = {
            pkcs7
        }
        return this.generationClient.post(`/api/v1/seats/${seatId}/credentials/${credentialId}/certificate`, body);
    }

    async listCredentials() {
        return this.usageClient.post(`/csc/v1/credentials/list`);
    }

    async certificateInfo(credentialId) {
        const body = {
            "credentialId": credentialId,
            "certificates": "none",
            "certInfo": true,
            "authInfo": true
        }
        return this.usageClient.post(`/csc/v1/credentials/info`, body);
    }

    async authorize(params) {
        return this.usageClient.post(`/csc/v1/credentials/authorize`, params);
    }

    async signHash(params) {
        return this.usageClient.post(`/csc/v1/signatures/signHash`, params);
    }
}
